// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.maingroups', {
        url: '/maingroups?searchTerm',
        views: {'productList@product': {
            templateUrl: 'main/product/maingroups/maingroups.tpl.html',
            controller: 'MainGroupsController as vm'
        }},
        resolve: {
            mainGroups: mainGroupsResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function mainGroupsResolver(MaingroupsApiService, $stateParams) {
    return MaingroupsApiService.getMainGroups({page: 0, searchTerm: $stateParams.searchTerm, itemsPerPage: null});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function MainGroupsController($rootScope, $state, $scope, mainGroups, MaingroupsApiService,loadSpinnerService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.mainGroups = mainGroups;
    vm.selectedMainGroupId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;
    vm.sortingKey = '';
    vm.sortingDesc = false;

    vm.searchTermChange = searchTermChange;
    vm.sortMainGroups = sortMainGroups

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.mainGroupId; }, function(newValue, oldValue) {
            vm.selectedMainGroupId = parseInt($state.params.mainGroupId,10);
        });

        $rootScope.$on('MainGroup.Changed', function(event, response) {
            loadMainGroups();
        });
    }

    function loadMainGroups() {
        loadSpinnerService.start('mainSpinner');
        console.log("vm.sortingDesc", vm.sortingDesc)
        MaingroupsApiService.getMainGroups({page: vm.currentPage - 1, searchTerm: vm.searchTerm, sortingKey: vm.sortingKey, sortingDesc: vm.sortingDesc, itemsPerPage: vm.itemsPerPage}).then(function(response) {
            vm.mainGroups = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function sortMainGroups(sortingKey){
        vm.sortingKey = sortingKey;
        vm.sortingDesc = !vm.sortingDesc;
        loadMainGroups();
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadMainGroups();
    }

}

angular
    .module('product.maingroups', ['maingroups.api','maingroups.maingroup'])
    .config(stateConfig)
    .controller('MainGroupsController', MainGroupsController);
